// extracted by mini-css-extract-plugin
module.exports = {"pintxo-badge-wrapper":"BadgeWrapper_pintxo-badge-wrapper__IEcl0","pintxo-badge-wrapper__badge":"BadgeWrapper_pintxo-badge-wrapper__badge__zjXXp"};